import { Grid } from '@material-ui/core'
import React from 'react'
import CustomInput from '../components/CustomInput'
function EditProductCatalougeComp({ state, setState }) {
  //console.log('STATE : ', state)

  const inputField = [{ label: 'Name' }, { label: 'Description' }, { label: 'Image', type: 'file' }]
  return (
    <Grid container style={{}} spacing={3}>
      {inputField.map((item, index) => (
        <Grid item lg={4} key={index}>
          <CustomInput label={item.label} icon={item.icon} name={item.name} value={item.value} number={item.number ? true : false} form={state} setForm={setState} formCheck={true} type={item.type} />
        </Grid>
      ))}
    </Grid>
  )
}

export default EditProductCatalougeComp
